import styled from "styled-components";

export const NHeader = styled.div`
  margin-bottom: 15%;
  @media (max-height: 641px) {
    margin-bottom: 10%;
  }
  @media (max-height: 585px) {
    margin-bottom: 10%;
  }
`;

export const NWelcomText = styled.p`
  color: #2b2928;
  font-family: Poppins;
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  line-height: 52px;
  margin: 0 0 48px 0;
`;

export const NLabel = styled.span`
  display: inline-block;
  color: #464646;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 12px;
`;

export const ScreenWrapper = styled.div`
  height: 500px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (max-height: 900px) {
    height: 450px;
  }
  @media (max-height: 800px) {
    height: 450px;
  }
  @media (max-height: 768px) {
    height: 430px;
  }
  @media (max-height: 641px) {
    height: 400px;
  }
  @media (max-height: 585px) {
    height: 400px;
  }
  @media (max-height: 551px) {
    height: 375px;
  }
`;

export const OTPHeader = styled.div`
  color: #2b2928;
  font-family: Poppins;
  font-size: 36px;
  font-style: normal;
  font-weight: 500;
  line-height: 52px; /* 144.444% */
`;

export const OTPContent = styled.div`
  color: #2b2928;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px; /* 187.5% */
  border-radius: 16px;
  background: rgba(231, 233, 255, 0.27);
  padding: 12px;

  .id {
    color: #2b2928;
    font-feature-settings: "liga" off, "clig" off;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 30px;
  }
`;

export const OTPResend = styled.div`
  text-align: right;
  margin-top: 4px;
  button {
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
    color: #536eb7;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    cursor: pointer;
  }
`;

export const OTPLabel = styled.span`
  display: inline-block;
  color: #464646;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 12px;
`;

export const OTPResendTimer = styled.div`
  .text {
    color: #4f4f4f;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px; /* 150% */
  }
  .timer {
    color: #dd3b38;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
  .resend {
    color: #536eb7;
    font-family: Poppins;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 150% */
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: none;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
  }
  button {
    background: none;
    border: none;
    outline: none;
    cursor: pointer;
  }
`;

export const ErrorText = styled.span`
  display: inline-block;
  color: #e4626f;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  margin-top: 4px;
`;

export const NTerms = styled.div`
  width: 80%;
  color: #4a5e6d;
  font-feature-settings: "liga" off, "clig" off;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  position: absolute;
  bottom: 5%;
  text-align: center;

  span{
    text-decoration: underline;
    cursor: pointer;
  }

  @media (max-height: 800px) {
    font-size: 14px;
  }

  @media (max-height: 760px) {
    bottom: 3%;
  }
  @media (max-height: 724px) {
    bottom: 2%;
  }
  @media (max-height: 710px) {
    bottom: 1%;
  }
  @media (max-height: 586px) {
    bottom: 0;
    font-size: 14px;
  }
`;
